import Axios from "axios";
import { errorResponse } from "../../../utils/apiHelpers/apiHelpers";
import { appConfigs } from "../../../utils/configurations";

export function orgreportAccessGet(
    me?: any,
    callbackSuccessFn?: any,
    callbackErrorFn?: any,
    selectedOrgId?: any
) {
    return async (dispatch: any) => {
        //console.log(selectedOrgId);
        await Axios.get(
            //`http://localhost:8080/ui/api/report-schedules/orgReportMapping/${selectedOrgId}`,
           appConfigs.server.URL + `/ui/api/report-schedules/orgReportMapping/${selectedOrgId}`, 
            {
                responseType: "json",        
                headers: {},
                params: {}
            }
        )
        .then(response => {                            
                if (callbackSuccessFn != null) {
                    callbackSuccessFn(response.data);
                }
                dispatch({ type: "ORGREPORT_ACCESS_SUCCESS", payload: {data: response.data.data.orgReportMappingList} });
            }
        )
        .catch(function (error) {                                
                if (callbackErrorFn != null) {
                    callbackErrorFn(error);
                }
                dispatch({ type: "REPORT_ACCESS_FAILURE", error: error });
            }
        );
    };
}
export function getReportsToken(
    me?: any,
    callbackSuccessFn?: any,
    callbackErrorFn?: any,
) {
    return async (dispatch: any) => {
        await Axios.get(
            //`http://localhost:8080/ui/api/report-schedules/generate`,
           appConfigs.server.URL + `/ui/api/report-schedules/generate`, 
            {
                responseType: "json",        
                headers: {},
                params: {}
            }
        )
        .then(response => {                            
                if (callbackSuccessFn != null) {
                    callbackSuccessFn(response);
                }
                dispatch({ type: "REPORTSTOKEN_ACCESS_SUCCESS", payload: {data: response.data} });
            }
        )
        .catch(function (error) {                                
                if (callbackErrorFn != null) {
                    callbackErrorFn(error);
                }
                dispatch({ type: "REPORTSTOKEN_ACCESS_FAILURE", error: error });
            }
        );
    };
}